module.exports = __webpack_public_path__ + "img/vertical_7_5_7005.2e409f1d.png";